import { render } from "./CommonVerificationCodeButton.vue?vue&type=template&id=b53b188c"
import script from "./CommonVerificationCodeButton.vue?vue&type=script&lang=js"
export * from "./CommonVerificationCodeButton.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Project\\Carryglobal\\GlobalLinkVIPNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__